import { render } from "./AddressIndex.vue?vue&type=template&id=95227032"
import script from "./AddressIndex.vue?vue&type=script&lang=js"
export * from "./AddressIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__